export const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(3),
    width: "100%",
    boxSizing: "border-box",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "8px",
  },
  listItem: {
    // width : '100%',
    height: "100%",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    position: "relative",
  },
  buttonIcon: {
    width: 64,
    height: 64,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  icon: {
    cursor: "pointer",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: 40,
  },
  buttonHover: {
    width: 36,
    height: 36,
    margin: "0px 5px",
  },
  iconHover: {
    cursor: "pointer",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    fontSize: 24,
  },
  inputImage: {
    display: "none",
  },
  imageItem: {
    height: "250px",
    cursor: "pointer",
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  title: {
    padding: 0,
    lineHeight: "normal",
    height: "3rem",
    color: "#000000",
    fontWeight: 900,
  },
  textField: {
    marginRight: theme.spacing(1),
    width: "100%",
  },
  label: {
    fontWeight: 410,
    color: "#000000",
  },
  formLabel: {
    marginBottom: theme.spacing(1),
    textTransform: "capitalize",
    fontSize: "16px",
  },

  button: {
    float: "right",
  },
  image: {
    height: "25vw",
    width: "45vw",
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
    // marginTop: `${theme.spacing(3)}px`,
  },
  marginTop: {
    marginTop: theme.spacing(3),
    // width: '100%'
  },
  customFormLabel: {
    display: "block",
    transformOrigin: "top left",
    transform: "translate(0, 1.5px) scale(0.75)",
    color: "rgba(0, 0, 0, 0.85)",
    fontWeight: "500",
  },
  inputType: {
    height: "unset",
  },
});
